import React, {Component} from 'react'
import './index.scss'
import {withRouter} from 'react-router'
// 轮播组件
@withRouter

export default class Swipes extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    var mySwiper = new window.Swiper('.swiper-container', {
      direction: 'horizontal', //横向切换选项
      loop: false, //循环模式选项
      slidesPerView : 'auto'
    })
  }

  render() {
    const {group} = this.props
    return (
      <div className="swiper-container">
        <div className="swiper-wrapper">
          {group.map((item, index) => {
            return <div className="swiper-slide"
                        onClick={this.props.goDetail.bind(this,item)}
                        key={index}>
              <div className="video_cover">
                <img src={item.big_cover} alt="封面图"/>
                <div className="video_play">
                  <div className="video_playIcon"></div>
                </div>
                <div className="swiperTimeBox">
                  <span className="play-icon"></span>
                  <span>{this.props.changeTime(item.ext_data.duration)}</span>
                </div>
              </div>
              <div className="video_title">{item.title}</div>
            </div>
          })}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Swipes/index.js